<template lang="pug">
  .advice
    .md-layout.md-gutter.widen
      .md-layout-item.md-size-100.md-small-size-100
        ration-card(:materials="materials" :mpd="meals" ref="ration")
    .md-layout.md-gutter.widen
      .md-layout-item.md-size-100.md-small-size-100
        stable-card(:mpd="meals" )
    .md-layout.md-gutter.widen
      .md-layout-item.md-size-100(v-if="ration.info && ration.info.length > 0")
        more-info(:details="ration.info")
      .md-layout-item.md-size-100
        personal-advice(:ration="$refs.ration")
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'advice',
  components: {
    StableCard: () => import('@/components/StableCard'),
    RationCard: () => import('@/components/RationCard'),
    MoreInfo: () => import('@/components/MoreInfo'),
    PersonalAdvice: () => import('@/components/PersonalAdvice')
  },
  data () {
    return {
      metric: true,
      expert: false
    }
  },
  computed: {
    ...mapState([
      'language',
      'horse',
      'user',
      'breedTypeIdx',
      'breedIdx',
      'breeds',
      'activityTypeIdx',
      'activityIdx',
      'activities',
      'phaseTypeIdx',
      'phaseIdx',
      'phases',
      'weights',
      'info'
    ]),
    ...mapState({
      weightID: 'weight',
      contact: state => state.activecampaign.contact,
      tags: state => state.activecampaign.tags,
      activityIdxTags: state => state.activecampaign.activityIdxTags
    }),
    ...mapGetters([
      'ration',
      'breedType',
      'breed',
      'weight',
      'phaseType',
      'phase',
      'activityType',
      'activity',
      'materials',
      'krachtvoer',
      'ruwvoer',
      'supplement'
    ]),
    meals () {
      return [this.ration.kvmpd, this.ration.rvmpd, 2]
    },
    productInfo () {
      return this.ration.products || []
    },
    careProductInfo () {
      return this.ration.care || []
    }
  },
  watch: {
    activityTypeIdx () {
      this.tagActivityType()
    },
    activityIdx () {
      this.tagActivity()
    }
  },
  methods: {
    toggleMetric () {
      this.metric = !this.metric
    },
    whereToBuy () {
      window.open('http://www.cavalor.com/int/where-to-buy/locations/1/0/0')
    },
    async tagActivityType () {
      const { id } = this.contact
      const tag = this.tags[this.activityTypeIdx]
      if (tag !== undefined) {
        // console.log(`Advice adding AC tag for activityType: ${this.activityTypeIdx}`)
        // add concern tag to contact id
        await this.$store.dispatch('activecampaign/addTag', { contactTag: { contact: id, tag } })
      }
    },
    async tagActivity () {
      const { id } = this.contact
      const tag = this.activityIdxTags[this.activityIdx]
      if (tag !== undefined) {
        // console.log(`Advice adding AC tag for activity: ${this.activityIdx} with tag ${tag}`)
        // add concern tag to contact id
        await this.$store.dispatch('activecampaign/addTag', { contactTag: { contact: id, tag } })
      }
    }
  }
}
</script>
<style scoped>
.widen {
  margin-left: -44px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Advice.vue